module.exports = __webpack_public_path__ + "img/11-Gris Anthracite Ulti Mat.jpg";